/* Wellina (Pebble clone) — interactions */
(function () {
  'use strict';

  /* Cart prices are formatted here, in JS, so Liquid's `money` filter is not
     available. The symbol must never be hardcoded — this store is INR and the
     currency can be changed at any time. Order of preference:
       1. shop.money_format, published by snippets/mobile-nav-css.liquid
       2. Intl with Shopify.currency.active
       3. the bare number
     Read lazily inside the call so script order does not matter. */
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    var fmt = window.WellinaMoneyFormat;
    if (fmt) {
      var withComma = function (n, dec) {
        var parts = n.toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      };
      // Show prices the way the rest of the site does: ₹1,250 rather than Rs. 1,250.00.
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma(v, 0))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(v, 2))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withComma(v, 0))
        .replace(/\{\{\s*amount\s*\}\}/g, withComma(v, 2))
        .replace(/^Rs\.\s?/, '₹')
        .replace(/\.00(?!\d)/, '');
    }
    try {
      var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      if (cur) return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(v);
    } catch (e) {}
    return v.toFixed(2);
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Mobile nav ---------- */
  function toggleMobileNav(open) {
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    nav.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-mobile-nav]')) { e.preventDefault(); toggleMobileNav(true); }
    if (e.target.closest('[data-close-mobile-nav]')) { e.preventDefault(); toggleMobileNav(false); }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('Overlay');

  /* Drawer styling is injected here rather than in base.css so the cart item
     markup below and its CSS stay in one place. Injected into <head> after
     base.css, so these rules win at equal specificity. */
  if (!document.getElementById('wellina-cart-css')) {
    var st = document.createElement('style');
    st.id = 'wellina-cart-css';
    st.textContent = [
      '@keyframes wl-spin{to{transform:rotate(360deg)}}',
      '.cart-spinner{display:inline-block;width:30px;height:30px;border:3px solid rgba(44,58,43,0.15);border-top-color:var(--color-forest,#2c3a2b);border-radius:50%;animation:wl-spin .7s linear infinite}',

      '.cart-drawer{--cd-ink:var(--color-text,#1c221d);--cd-soft:rgba(44,58,43,0.10);--cd-muted:rgba(28,34,29,0.62);background:#fff;color:var(--cd-ink);border-start-start-radius:var(--radius,24px);border-end-start-radius:var(--radius,24px);display:flex;flex-direction:column;overflow:hidden}',

      '.cart-drawer__head{display:flex;align-items:center;justify-content:space-between;gap:1rem;padding:1.35rem 1.5rem;border-bottom:1px solid var(--cd-soft);flex-shrink:0}',
      '.cart-drawer__head h3{font-family:var(--font-heading);font-weight:400;font-size:1.45rem;margin:0}',

      '.cart-drawer__body{flex:1;overflow-y:auto;overscroll-behavior:contain;padding:0 1.5rem}',
      '.cart-empty{padding:3.5rem 0;text-align:center;color:var(--cd-muted)}',

      '.cart-item{display:flex;gap:1rem;padding:1.15rem 0;border-bottom:1px solid var(--cd-soft)}',
      '.cart-item:last-child{border-bottom:0}',
      '.cart-item__media{width:76px;height:96px;border-radius:14px;overflow:hidden;flex-shrink:0;background:var(--color-sage-soft,#eef0e8);display:block}',
      '.cart-item__media img{width:100%;height:100%;object-fit:cover;display:block}',
      '.cart-item__info{flex:1;min-width:0;display:flex;flex-direction:column}',
      '.cart-item__title{font-family:var(--font-heading);font-size:1.05rem;line-height:1.3;color:var(--cd-ink);text-decoration:none}',
      '.cart-item__title:hover{text-decoration:underline;text-underline-offset:3px}',
      '.cart-item__variant{font-size:0.82rem;color:var(--cd-muted);margin-top:0.15rem}',
      '.cart-item__price{display:flex;align-items:baseline;gap:0.5rem;margin-top:0.4rem;flex-wrap:wrap}',
      '.cart-item__now{font-weight:600;font-size:0.98rem}',
      '.cart-item__now.is-sale{color:#c0392b}',
      '.cart-item__was{color:var(--cd-muted);font-size:0.88rem;text-decoration:line-through}',
      '.cart-item__off{font-size:0.8rem;font-weight:600;color:#2e9e54}',
      '.cart-item__row{display:flex;align-items:center;justify-content:space-between;gap:0.75rem;margin-top:auto;padding-top:0.65rem}',

      '.cart-item__qty{display:inline-flex;align-items:center;gap:0.15rem;border:1.5px solid var(--cd-soft);border-radius:999px;padding:0.15rem}',
      '.cart-item__qty button{width:1.9rem;height:1.9rem;border:0;background:none;border-radius:999px;cursor:pointer;color:var(--cd-ink);font-size:1rem;line-height:1;display:grid;place-items:center;transition:background .2s ease}',
      '.cart-item__qty button:hover{background:var(--color-sage-soft,#eef0e8)}',
      '.cart-item__qty input{width:1.6rem;border:0;background:none;text-align:center;font-size:0.9rem;color:var(--cd-ink);padding:0;-moz-appearance:textfield}',
      '.cart-item__qty input::-webkit-outer-spin-button,.cart-item__qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}',
      '.cart-item__remove{border:0;background:none;padding:0;font-size:0.8rem;color:var(--cd-muted);text-decoration:underline;text-underline-offset:2px;cursor:pointer;transition:color .2s ease}',
      '.cart-item__remove:hover{color:var(--cd-ink)}',

      '.cart-drawer__foot{flex-shrink:0;padding:1.25rem 1.5rem 1.5rem;border-top:1px solid var(--cd-soft);background:#fff}',
      '.cart-drawer__foot.hide{display:none}',
      '.cart-drawer__subtotal{display:flex;align-items:baseline;justify-content:space-between;gap:1rem;margin-bottom:0.9rem}',
      '.cart-drawer__subtotal span:first-child{font-family:var(--font-heading);font-size:1.05rem}',
      '.cart-drawer__subtotal span:last-child{font-weight:600;font-size:1.15rem}',
      '.cart-drawer__foot .btn{display:flex;align-items:center;justify-content:center;gap:0.6rem;width:100%;padding:1rem 1.25rem;border-radius:var(--button-radius,999px);background:var(--color-lime-real,#e2f0a2);color:var(--color-forest,#2c3a2b);font-weight:600;font-size:1rem;text-decoration:none;transition:filter .25s ease,transform .25s ease}',
      '.cart-drawer__foot .btn:hover{filter:brightness(1.05);transform:translateY(-1px)}',
      '.cart-drawer__foot .btn__arrow svg{width:1.05rem;height:1.05rem;display:block}',

      '@media (max-width:749px){.cart-drawer{border-radius:0}.cart-drawer__head,.cart-drawer__body,.cart-drawer__foot{padding-left:1.1rem;padding-right:1.1rem}}',
      '@media (prefers-reduced-motion:reduce){.cart-drawer__foot .btn,.cart-item__qty button{transition:none}}'
    ].join('');
    document.head.appendChild(st);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function showCartLoading() {
    var body = document.querySelector('[data-cart-body]');
    if (body) body.innerHTML = '<div class="cart-loading" style="display:flex;justify-content:center;align-items:center;padding:3.5rem 0"><span class="cart-spinner"></span></div>';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(); refreshCart(); }
    if (e.target.closest('[data-close-cart]') || e.target.id === 'Overlay') { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); toggleMobileNav(false); } });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hide', count === 0);
    });
  }

  /* ---------- MRP (compare-at) in the drawer ----------
     /cart.js carries no compare_at_price — only the discounted and original
     LINE prices, which are equal unless a cart discount applies. The MRP lives
     on the product, so it is fetched per handle (cached, one request each) and
     patched in after the drawer has already painted. A failed lookup just
     leaves the line showing its price, which is the current behaviour. */
  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .catch(function (err) { console.warn('[cart] compare-at lookup failed for ' + handle, err); return null; });
    }
    return productCache[handle];
  }

  function rowForKey(key) {
    var rows = document.querySelectorAll('.cart-item');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-key') === key) return rows[i];
    }
    return null;
  }

  function addCompareAt(items) {
    items.forEach(function (item) {
      if (!item.handle) return;
      fetchProduct(item.handle).then(function (p) {
        if (!p || !p.variants) return;
        var v = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].id === item.variant_id) { v = p.variants[i]; break; }
        }
        if (!v || !v.compare_at_price || v.compare_at_price <= v.price) return;

        var row = rowForKey(item.key);
        if (!row) return;
        var wrap = row.querySelector('.cart-item__price');
        if (!wrap || wrap.querySelector('.cart-item__was')) return;

        var was = v.compare_at_price * item.quantity;
        var off = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
        var now = wrap.querySelector('.cart-item__now');
        if (now) now.classList.add('is-sale');
        wrap.insertAdjacentHTML('beforeend',
          '<s class="cart-item__was">' + money(was) + '</s>' +
          (off > 0 ? '<span class="cart-item__off">' + off + '% off</span>' : ''));
      });
    });
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;
    updateCartCount(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>' + esc(window.WellinaStrings ? window.WellinaStrings.empty : 'Your cart is empty') + '</p></div>';
      if (foot) foot.classList.add('hide');
      return;
    }
    if (foot) foot.classList.remove('hide');
    var html = '';
    cart.items.forEach(function (item) {
      var onSale = item.original_line_price > item.final_line_price;
      html += '<div class="cart-item" data-key="' + esc(item.key) + '">' +
        '<a class="cart-item__media" href="' + esc(item.url) + '">' +
          (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-item__info">' +
          '<a class="cart-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (item.variant_title ? '<div class="cart-item__variant">' + esc(item.variant_title) + '</div>' : '') +
          '<div class="cart-item__price">' +
            '<span class="cart-item__now' + (onSale ? ' is-sale' : '') + '">' + money(item.final_line_price) + '</span>' +
            (onSale ? '<s class="cart-item__was">' + money(item.original_line_price) + '</s>' : '') +
          '</div>' +
          '<div class="cart-item__row">' +
            '<div class="cart-item__qty qty">' +
              '<button type="button" data-cart-minus aria-label="Decrease quantity">&minus;</button>' +
              '<input value="' + esc(item.quantity) + '" readonly aria-label="Quantity">' +
              '<button type="button" data-cart-plus aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-item__remove" data-cart-remove>Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    });
    body.innerHTML = html;
    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    addCompareAt(cart.items);
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  /* Expose for the quick-view modal */
  window.WellinaCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart, loading: showCartLoading };

  function changeCart(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var itemEl = e.target.closest('.cart-item');
    if (!itemEl) return;
    var key = itemEl.getAttribute('data-key');
    var input = itemEl.querySelector('input');
    var qty = parseInt(input.value, 10);
    if (e.target.closest('[data-cart-plus]')) changeCart(key, qty + 1);
    if (e.target.closest('[data-cart-minus]')) changeCart(key, Math.max(0, qty - 1));
    if (e.target.closest('[data-cart-remove]')) changeCart(key, 0);
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.querySelector('.btn-label') : null;
    if (original) original.textContent = 'Adding…';
    /* Open drawer INSTANTLY (optimistic UI) + show loading spinner */
    openDrawer();
    showCartLoading();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(serialize(form))
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (original) original.textContent = 'Added ✓';
        refreshCart();
        setTimeout(function () { if (original) original.textContent = form.getAttribute('data-add-label') || 'Add to cart'; }, 1500);
      })
      .catch(function () { if (original) original.textContent = 'Add to cart'; refreshCart(); });
  });

  function serialize(form) {
    var data = new FormData(form);
    var obj = { items: [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10) }] };
    return obj;
  }

  /* ---------- Product-card cart button ----------
     Single-variant cards carry data-card-add, so there is nothing to choose:
     add it and show the cart drawer that already exists. Cards for products
     with several variants keep data-quick-view instead, since that is where
     the option picker lives. Same optimistic pattern as the product form —
     drawer first, spinner over the request. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.cardBusy) return;
    btn.dataset.cardBusy = '1';
    openDrawer();
    showCartLoading();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: btn.getAttribute('data-card-add'), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .catch(function (err) { console.error('[card-add]', err); })
      .then(function () { delete btn.dataset.cardBusy; refreshCart(); });
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.addEventListener('click', function (e) {
    var stepper = e.target.closest('[data-qty]');
    if (!stepper) return;
    var wrap = e.target.closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    if (e.target.closest('[data-qty="plus"]')) input.value = v + 1;
    if (e.target.closest('[data-qty="minus"]')) input.value = Math.max(1, v - 1);
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-gallery-main] img');
    var full = thumb.getAttribute('data-full');
    if (main && full) main.src = full;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('[data-product-form]');
    picker.addEventListener('change', function () {
      var selected = {};
      picker.querySelectorAll('input:checked').forEach(function (input) {
        selected[input.name] = input.value;
      });
      var variants = JSON.parse(picker.getAttribute('data-variants') || '[]');
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected['option' + (i + 1)] === opt; });
      });
      if (match && form) {
        var idInput = form.querySelector('[name="id"]');
        if (idInput) idInput.value = match.id;
        var priceEl = document.querySelector('[data-product-price]');
        if (priceEl) priceEl.textContent = money(match.price);
        var btn = form.querySelector('[type="submit"] .btn-label');
        if (btn) btn.textContent = match.available ? (form.getAttribute('data-add-label') || 'Add to cart') : 'Sold out';
      }
    });
  });

  /* ---------- Accordion ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    var item = trigger.closest('.accordion__item');
    var panel = item.querySelector('.accordion__panel');
    var isOpen = item.classList.toggle('is-open');
    panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0';
  });

  /* ---------- Sort redirect ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Header: drop the exit animation ----------
     The sticky routine in sections/header.liquid adds .is-unstick on scroll
     up. While that class is on, the header stays position:fixed at top:0 and
     plays a 0.4s slide to translateY(-45%), then snaps back to its normal
     inline spot 18px down. Measured on the live theme, that leaves the header
     pinned at the top for ~400ms after you have already scrolled back up,
     which is what reads as the header sticking.

     Removing the class as soon as it appears restores the exact pre-stick
     state with no animation, so the header returns to place immediately.
     The scroll-down entrance animation is left alone. */
  function patchUnstick() {
    var outer = document.querySelector('.header-outer');
    if (!outer || outer.dataset.unstickPatched) return;
    outer.dataset.unstickPatched = '1';
    function drop() {
      if (!outer.classList.contains('is-unstick')) return;
      outer.classList.remove('is-unstick');
      outer.style.height = '';
    }
    drop();
    new MutationObserver(drop).observe(outer, { attributes: true, attributeFilter: ['class'] });
  }
  patchUnstick();
  /* The theme editor re-renders the header section on every setting change,
     which replaces .header-outer and loses the observer. */
  document.addEventListener('shopify:section:load', patchUnstick);

  /* Init cart count on load */
  refreshCart();
})();
